<template>
  <div :id="this.$vnode.key === 1 ? 'crop-image-page' : ''" class="crop-image-page" v-if="report">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px; position: relative;">
      <div class="d-flex justify-start mb-3">
        <span class="text-h5 font-weight-bold my-auto" style="height: 36px;">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）') - 1}}. ドローン検査詳細（抜粋）</span>
        <span class="text-h5 font-weight-bold my-auto red--text" v-if="selectedImages.filter(i => i.src).length === 0">（必須）</span>
        <v-btn @click="openChooseCropImageDialog" color="primary" v-show="editMode">画像選択</v-btn>
      </div>
      <div v-for="(image, index) in images" :key="index">
        <v-row v-if="image.src">
          <v-col>
            <img :src="image.src.concat('?timestamp=' + Date.now())" style="height: 280px; width: 350px;" />
          </v-col>
          <v-col>
            <div v-show="!editMode">
              <p class="text-subtitle-1 font-weight-bold pt-1 text-justify" style="border-bottom: 2px solid #000">
                {{errorType[image.errorType]}}
                <span v-if="image.errorReason">
                  （{{errorReason[image.errorReason]}}）
                </span>
              </p>
              <p class="text-subtitle-1 text-justify" v-html="displayNote(image.errorNote)">
              </p>
            </div>
            <div v-show="editMode">
              <div>
                <v-row>
                  <v-col cols="7">
                    <v-select
                        clearable
                        label="種類"
                        @change="saveImageType(image)"
                        outlined
                        hide-details
                        dense
                        v-model="image.errorType"
                        :items="errorTypes"
                    ></v-select>
                  </v-col>
                  <v-col cols="5">
                    <v-select
                        :disabled="image.errorType === 'shadow'"
                        clearable
                        label="原因"
                        @change="saveImageReason(image)"
                        outlined
                        hide-details
                        dense
                        v-model="image.errorReason"
                        :items="errorReasons"
                    ></v-select>
                  </v-col>
                </v-row>
              </div>
              <v-textarea
                  clearable
                  label="備考"
                  outlined
                  dense
                  @change="saveImageNote(image)"
                  v-model="image.errorNote"
                  hide-details="auto"
                  rows="7"
                  no-resize
              ></v-textarea>
            </div>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col v-show="editMode">
            <div style="height: 280px; width: 100%; background-color: whitesmoke;" class="d-flex align-center justify-center">
              <v-btn outlined @click="removeBlank(index)" color="error"><v-icon>mdi-close-circle-outline</v-icon>ブランク削除</v-btn>
            </div>
          </v-col>
          <v-col v-show="!editMode">
            <div style="height: 280px; width: 100%;"></div>
          </v-col>
        </v-row>
        <div style="position: relative" v-show="editMode">
          <div style="border: 1px solid #1976D2"></div>
          <div style="position: absolute; top: -12px; left: calc(50% - 56px)">
            <v-chip x-small color="primary" @click="addBlank(index)">
              <v-icon small>mdi-plus-circle-outline</v-icon>
              ブランク追加
            </v-chip>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">{{naviVisibleList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）') + this.$vnode.key + 2}}/{{naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CropImagePage",
  props: ['report', 'selectedImages', 'naviVisibleList', 'cropImagePageNum', 'editMode', 'printMode', 'pdfPageNum'],
  data() {
    return {
      errorType: {
        'cell': 'ホットスポット',
        'multicell': 'マルチホットスポット',
        'cluster': 'クラスタバイパス',
        'module': 'モジュール異常',
        'string': 'ストリング異常',
        'junction': 'ジャンクションボックス過熱',
        'pid': 'ＰＩＤ現象の疑い',
        'shadow': '影',
      },
      errorTypes: [
        { text: "ホットスポット", value: "cell"},
        { text: "マルチホットスポット", value: "multicell"},
        { text: "クラスタバイパス", value: "cluster" },
        { text: "モジュール異常", value: "module"},
        { text: "ストリング異常", value: "string"},
        { text: "ジャンクションボックス過熱", value: "junction" },
        { text: "ＰＩＤ現象の疑い", value: "pid" },
        {text: "影", value: "shadow"},
      ],
      errorReason: {
        "crack": "割れ",
        "sediment": "堆積物",
        "vegetation": "植生"
      },
      errorReasons: [
        {text: "割れ", value: "crack"},
        {text: "堆積物", value: "sediment"},
        {text: "植生", value: "vegetation"},
      ],
      test: null,
      images: [],
      folderId: this.$route.params.folderId,
      errorNotes: {
        type: {
          'cell': 'モジュールの一部に発熱が見受けられます。',
          'multicell': '複数のセルに発熱が見受けられます。',
          'cluster': 'クラスタ全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'string': 'ストリング全体が発熱している状態となっております。発熱箇所が発電に寄与していないもしくは、性能が極端に低下していると推定されます。',
          'shadow': '周囲の構造物・樹木によりモジュールに影がかかっております。\nこれにより、発電量が低下していると推定されます。',
          'junction': 'ジャンクションボックスが過熱している状態となっております。',
          'module': 'モジュール全体が発熱している状態となっております。\n本パネルは発電に寄与していないと推定されますので、取り換えを推奨いたします。',
          'pid': 'PID現象が発生していると推定されます。',
          null: ''
        },
        reason: {
          null: '',
          'unknown': '',
          'vegetation': 'こちらはモジュールセルを覆う草木の影により発生していると推定されます。',
          'sediment': 'こちらは堆積物により発生していると推定されます。',
          'crack': 'モジュールガラス面が割れており、絶縁性能低下に伴うPCS停止により発電量低下等を引き起こす可能性がありますので、取り換えを推奨いたします。'
        }
      }
    }
  },
  methods: {
    openChooseCropImageDialog(){
      this.$emit('openChooseCropImageDialog');
    },
    removeImageTypeInputFocus(index){
      this.$refs.imageType[index].blur();
    },
    saveImageType(image){
      if (!image.errorType){
        image.errorType = null;
        image.errorNote = this.errorNotes.reason[image.errorReason];
      }
      else{
        if (image.errorType === 'shadow'){
          image.errorReason = null;
          this.axios.put('/api/report/update/crop-image-reason/' + this.folderId, {image: image})
        }
        image.errorNote = this.errorNotes.type[image.errorType] + '\n' + this.errorNotes.reason[image.errorReason];
      }
      this.saveImageNote(image);
      this.axios.put('/api/report/update/crop-image-type/' + this.folderId, {image: image})
    },
    saveImageReason(image){
      if (!image.errorReason){
        image.errorReason = null;
      }
      if (!image.errorType){
        image.errorType = null;
        image.errorNote = this.errorNotes.reason[image.errorReason];
      }
      else{
        image.errorNote = this.errorNotes.type[image.errorType] + '\n' + this.errorNotes.reason[image.errorReason];
      }
      this.saveImageNote(image);
      this.axios.put('/api/report/update/crop-image-reason/' + this.folderId, {image: image})
    },
    saveImageNote(image){
      this.axios.put('/api/report/update/crop-image-note/' + this.folderId, {image: image})
    },
    displayNote(note){
      if (note){
        return note.replace('\n', '<br>');
      }
      else return null;
    },
    addBlank(index){
      const key = this.$vnode.key;
      const start = (key - 1) *3;
      this.$emit('addBlank', start + index + 1);
    },
    removeBlank(index){
      const key = this.$vnode.key;
      const start = (key - 1) *3;
      this.$emit('removeBlank', start + index);
    }
  },
  created() {
    const key = this.$vnode.key;
    if (key * 3 > this.selectedImages.length){
      this.images = this.selectedImages.slice((key - 1) *3, this.selectedImages.length);
    }
    else {
      this.images = this.selectedImages.slice((key - 1) *3, key*3);
    }
  },
  watch: {
    selectedImages(selectedImages){
      const key = this.$vnode.key;
      if (key * 3 > selectedImages.length){
        this.images = selectedImages.slice((key - 1) *3, selectedImages.length);
      }
      else {
        this.images = selectedImages.slice((key - 1) *3, key*3);
      }
    }
  },
}
</script>

<style scoped>

</style>
